import Backbone from 'backbone';

Backbone.$ = $;

const SelectorLabelView = Backbone.View.extend({
  initialize(options) {
    this.systemName = options.systemName;
  },
  render() {
    const point = this.collection.getPoint(this.systemName);
    if (point) {
      this.$el.html(point.displayName);
    }
  },
});

export default SelectorLabelView;
